<template>
  <div class="user-list">
    <div class="search-bar">
      <el-input
        v-model="searchParam.keyword_search"
        placeholder="输入用户昵称/手机号筛选"
        clearable
        @clear="getList"
      ></el-input>
      <el-date-picker
        v-model="dates"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="changeDate"
      >
      </el-date-picker>
      <el-button type="primary" @click="getList('clear')">查询</el-button>
      <el-button type="primary" @click="toDetail">新增发放</el-button>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="uuid" label="名称" fixed="left" width="120px">
          <template v-if="scope.row.certificate" slot-scope="scope">
            {{ scope.row.certificate.title }}
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120px"> </el-table-column>
        <el-table-column prop="real_name" label="联络人姓名" width="120px"> </el-table-column>

        <el-table-column prop="create_time" label="创建时间"> </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-red" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { certificateUser, delCertificateUser } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      teacherList: [],
      dates: [],
      searchParam: {
        keyword_search: "",

        start_time: "",
        end_time: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeDate(val) {
      if (Array.isArray(val)) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
        this.getList();
      }
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/distribution-add",
        query: this.$route.query,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    agree() {},
    delItem(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCertificateUser(row.id).then((res) => {
            if (res == true) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        certificate_uuid: this.$route.query.uuid,
      };
      this.loading = true;
      const res = await certificateUser(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
